import { ReportType } from "@/models/enum-types/report-type.enum";
import ConsolidatedReportStrategy from "./consolidated-report.strategy";
import ReportStrategy from "./report.strategy";
import SimpleReportStrategy from "./simple-report.strategy";
import SpeedReportStrategy from "./speed-report.strategy";
import StoppageReportStrategy from "./stoppage-report.strategy";
import TravelReportStrategy from "./travel-report.strategy";
import IDeviceStore from "@/models/modelStore/IDeviceStore";

export default class ReportStrategyFactory {
    static create(report: { type: string }, data: any, device: IDeviceStore): ReportStrategy {
        switch (report.type) {
            case ReportType.CONSOLIDATED_REPORT:
                return new ConsolidatedReportStrategy(report, data, device)

            case ReportType.SIMPLE_REPORT:
                return new SimpleReportStrategy(report, data, device)

            case ReportType.SPEED_REPORT:
                return new SpeedReportStrategy(report, data, device)

            case ReportType.STOPPAGE_REPORT:
                return new StoppageReportStrategy(report, data, device)

            case ReportType.TRAVEL_REPORT:
                return new TravelReportStrategy(report, data, device)

            default:
                return new SimpleReportStrategy(report, data, device)
        }
    }
}